export enum RewardType {
  GENERAL,
  TOWNESQUARE
}